// extracted by mini-css-extract-plugin
export default {"region":"Region_region__REdtE"};